import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
    InputType,
} from '@fitogest/reactive-form-builder/interfaces';
import { MaquinariaAlbaranModel } from 'src/app/models/ventas/tablas-maestras.model';
import { environment } from 'src/environments/environment';

export class MaquinariaFormDefinition {
  public readonly appName = environment.appName;
  public lastFieldChanged = '';
  public requestType: FormType = FormType.CREATION;
  public model: Partial<MaquinariaAlbaranModel> = {};
  public formFields: Form<MaquinariaAlbaranModel>;

  constructor(type: FormType, model: Partial<MaquinariaAlbaranModel>) {
    this.requestType = type;
    this.model = model;
    this.formFields = {
      name: 'albaran-maquinaria',
      header: 'Datos de la maquinaria',
      type: +type as FormType,
      sections: this.getSections(),
      table: null,
      uploadButton: {
        isEnabled: false,
        label: '',
      },
      signed: false,
    };
  }

  public handleFormValueChange(tag: string): void {
    this.lastFieldChanged = tag;
  }

  private getSections(): FormSection<MaquinariaAlbaranModel>[] {
    return [
      {
        name: '',
        fields: this.getFields(),
        width: 12,
        isVisible: true,
        order: 1,
      },
    ];
  }

  private getFields(): FormField<MaquinariaAlbaranModel>[] {
    return [
      this.textField('nombre', 'Nombre', 1, true),
      this.textField('ref_proveedor', 'Ref. Proveedor', 2),
      this.textField('proveedor', 'Proveedor', 3),
      this.textField('familia', 'Familia', 4),
      this.textField('existencias', 'Existencias', 5),
      this.textField('pvp', 'P.V.P', 6, true),
      this.textField('pvp_iva_inc', 'P.V.P IVA INC', 7, true),
    ];
  }

  private textField(
    name: keyof MaquinariaAlbaranModel & string,
    label: string,
    order: number,
    isRequired = false,
  ): FormField<MaquinariaAlbaranModel> {
    return {
      name,
      label,
      input: {
        type: InputType.TEXT,
        isEditable: true,
      },
      width: 4,
      conditions: this.conditions({ isRequired }),
      order,
    };
  }

  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }
}
